import { Timeline, Date } from './date-time';
import { Room } from './room';
import { User } from './users';
import { Team } from './team';

export const CONFERENCE_TYPES = {
    SOLID: 'SOLID',
    IFFY: 'IFFY'
};

export class Conference {
    id: number;
    room: Room;
    reservator: User;
    date: Date;
    timelines: Timeline[];
    team: Team;
    type: string;

    public isIffy(): boolean {
        return this.type == CONFERENCE_TYPES.IFFY;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/conference.ts